window.videoGalleryUtils = function videoGalleryUtils() {};

// Explicitly init on pages with videos,
// after including lightGallery.js

videoGalleryUtils.init = function() {
  lightGallery(document.getElementById('video-gallery'), {
    selector: '.c-videoGrid__item',
    download: false,
    counter: false,
    width: '840px',
    height: '474px',
    addClass: 'lg--video',
    preload: 3,
    speed: 250,
    share: false,
    startClass: 'lg-start-fade'
  });
};
